/** Consolidated Cloud Function `corrections` (see cloud-functions-asr recap/openapi/corrections.yml). */
export const correctionsPath = '/corrections';

export const correctionsProposePath = `${correctionsPath}/propose`;

export function correctionsGetOneQuery(correctionId: string, fileId: string, workspaceId: string) {
  const params = new URLSearchParams({
    correctionId,
    fileId,
    workspaceId,
  });
  return `${correctionsPath}?${params.toString()}`;
}
